// VE caches the hotel price for this many adults in one room (voyage-engine Arrangement::defaultPackagePrice).
const CACHED_ROOM_GUESTS = 2;

class PriceCalculationService {
    /**
     * Calculate all package type prices for an arrangement
     * @param {Object} arrangement
     * @returns {Object}
     */
    calculatePackagePrices(arrangement) {
        const selectedTicketPrice = arrangement.price.ticket,
         hotelPrice = arrangement.price.hotel * arrangement.datesIntervalum,
         flightPrice = arrangement.price.flight || 0,
         discount = arrangement.price.discount || 0;

        return {
            'flight': selectedTicketPrice + flightPrice + hotelPrice - discount,
            'hotel' : selectedTicketPrice + hotelPrice - discount,
            'ticket': selectedTicketPrice
        };
    }

    /**
     * Whether the cached price can be shown as a total for the selected rooms. VE caches the hotel
     * as one room with two adults, split per person; any other room split books a different rate.
     * shortcut: other splits show no total until VE serves a price per occupancy.
     * @param {{rooms?: Array<{num_guests: string}>, usesVoyageEnginePrices: boolean, includesHotel: boolean}} selection
     * @returns {boolean}
     */
    canQuoteTotal({rooms = [], usesVoyageEnginePrices, includesHotel}) {
        if (!usesVoyageEnginePrices || !includesHotel) {
            return true;
        }

        return rooms.every((room) => Number(room.num_guests) === CACHED_ROOM_GUESTS);
    }
}

export default new PriceCalculationService();